import {
  TableCellText,
} from "@ceridianhcm/components";

export const ErrorColumnsDefinitions = () => {
  
  return [
    {
      field: "severity",
      label: "Error",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.severity}>
            {cellContext.rowData.severity}
          </div>
        </TableCellText>
      ),
    },
    {
      field: "message",
      label: "Message",
      cellTemplate: (cellContext: any) => (
        <TableCellText>
          <div title={cellContext.rowData.message}>
            {cellContext.rowData.message}
          </div>
        </TableCellText>
      ),
    }
  ];
};
